import { render } from "./RoundText.vue?vue&type=template&id=54efc14c&scoped=true"
import script from "./RoundText.vue?vue&type=script&lang=js"
export * from "./RoundText.vue?vue&type=script&lang=js"

import "./RoundText.vue?vue&type=style&index=0&id=54efc14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54efc14c"]])

export default __exports__